function listCacheClear(){this.__data__=[],this.size=0}module.exports=listCacheClear;